export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14015.54407f07.jpg";